/**
 * Configuration for signature templates in document admin
 * These templates can be inserted into HTML documents via the admin interface
 */

export interface SignatureTemplate {
    id: string;
    name: string;
    description: string;
    html: string;
}

export const SIGNATURE_TEMPLATES: SignatureTemplate[] = [
    {
        id: 'signature_small',
        name: 'Klein',
        description: 'Kleine Signatur (25% Breite)',
        html: `<!-- Klein -->
<div style="width:25%;max-width:180px;text-align:center;color:#004aad;font-family:system-ui,sans-serif;margin:20px auto;">
  <img id="signatureImage" 
       src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/w8AAn8B9pQnUgAAAABJRU5ErkJggg==" 
       alt="Unterschrift" 
       style="max-width:100%;height:auto;display:block;margin:0 auto 8px;">
  <div style="border-top:2px solid #004aad;margin:8px 0;"></div>
  <div id="signatureText" style="font-size:12px;color:#004aad;"></div>
</div>`,
    },
    {
        id: 'signature_medium',
        name: 'Mittel',
        description: 'Mittlere Signatur (33% Breite)',
        html: `<!-- Mittel -->
<div style="width:33%;max-width:260px;text-align:center;color:#004aad;font-family:system-ui,sans-serif;margin:20px auto;">
  <img id="signatureImage" 
       src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/w8AAn8B9pQnUgAAAABJRU5ErkJggg==" 
       alt="Unterschrift" 
       style="max-width:100%;height:auto;display:block;margin:0 auto 8px;">
  <div style="border-top:2px solid #004aad;margin:8px 0;"></div>
  <div id="signatureText" style="font-size:14px;color:#004aad;"></div>
</div>`,
    },
    {
        id: 'signature_large',
        name: 'Groß',
        description: 'Große Signatur (50% Breite)',
        html: `<!-- Groß -->
<div style="width:50%;max-width:400px;text-align:center;color:#004aad;font-family:system-ui,sans-serif;margin:20px auto;">
  <img id="signatureImage" 
       src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/w8AAn8B9pQnUgAAAABJRU5ErkJggg==" 
       alt="Unterschrift" 
       style="max-width:100%;height:auto;display:block;margin:0 auto 8px;">
  <div style="border-top:2px solid #004aad;margin:8px 0;"></div>
  <div id="signatureText" style="font-size:16px;color:#004aad;"></div>
</div>`,
    },
];

/**
 * Get all available signature templates
 */
export function getAllSignatureTemplates(): SignatureTemplate[] {
    return SIGNATURE_TEMPLATES;
}

/**
 * Get signature template by ID
 */
export function getSignatureTemplate(id: string): SignatureTemplate | undefined {
    return SIGNATURE_TEMPLATES.find(template => template.id === id);
}
